import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UiEventsService {
  private changePasswordDialogSubject = new Subject<void>();
  changePasswordDialog$ = this.changePasswordDialogSubject.asObservable();

  private isDialogOpen = false;

  requestOpenChangePasswordDialog() {
    if (!this.isDialogOpen) {
      this.isDialogOpen = true;
      this.changePasswordDialogSubject.next();
    }
  }

  markDialogClosed() {
    this.isDialogOpen = false;
  }
}
